import { combineReducers } from 'redux';
import { connectRouter, RouterState } from 'connected-react-router';

import auth, { IAuthState } from '../reducers/Auth';
import task, { ITaskState } from '../reducers/Task';
import layout, { ILayoutState } from '../reducers/Layout';
import client, { IClientState } from '../reducers/Client';
import company, { ICompanyState } from '../reducers/Company';
import project, { IProjectState } from '../reducers/Project';
import projectStaffing, { IProjectStaffingState } from '../reducers/ProjectStaffing';
import landman, { ILandmanState } from '../reducers/Landman';
import performanceComment, { IPerformanceCommentState } from '../reducers/PerformanceComment';
import user, { IUserState } from '../reducers/User';
import office, { IOfficeState } from '../reducers/Office';
import profile, { IProfileState } from './Profile';
import state, { IStateState } from './State';
import tract, { ITractState } from './Tract';
import search, { ISearchState } from './Search';
import owner, { IOwnerState } from './Owner';
import phoneNumberType, { IPhoneNumberTypeState } from './PhoneNumberType';
import leasehold, { ILeaseholdState } from '../reducers/Leasehold';
import fileManagement, { IFileManagement } from '../reducers/FileManagement';
import navigation, { INavigationState } from '../reducers/Navigation';
import leaseClause, { ILeaseClauseState } from '../reducers/Clause';
import leaseGeneration, { ILeaseGenerationState } from '../reducers/LeaseGeneration';
import feedback, { IFeedbackState } from '../reducers/Feedback';
import personnel, { IPersonnelState } from '../reducers/Personnel';

import { History } from 'history';
import county, { ICountyState } from './County';
import ownershipContactCategories, { IOwnershipContactCategoriesState } from './OwnershipContactCategories';
import tags, { ITagState } from './Tag';
import invoice, { IInvoiceState } from './Invoice';
import appContext, { IAppContextState } from './AppContext';
import documentTemplates, { IDocumentTemplatesState } from './DocumentTemplates';

export interface IRootState {
    router: RouterState;
    auth: IAuthState;
    task: ITaskState;
    layout: ILayoutState;
    client: IClientState;
    company: ICompanyState;
    project: IProjectState;
    projectStaffing: IProjectStaffingState;
    landman: ILandmanState;
    performanceComment: IPerformanceCommentState;
    user: IUserState;
    office: IOfficeState;
    profile: IProfileState;
    state: IStateState;
    tract: ITractState;
    search: ISearchState;
    owner: IOwnerState;
    phoneNumberType: IPhoneNumberTypeState;
    county: ICountyState;
    leasehold: ILeaseholdState;
    fileManagement: IFileManagement;
    navigation: INavigationState;
    leaseClause: ILeaseClauseState;
    leaseGeneration: ILeaseGenerationState;
    feedback: IFeedbackState;
    ownershipContactCategories: IOwnershipContactCategoriesState;
    documentTemplates: IDocumentTemplatesState;
    tags: ITagState;
    invoice: IInvoiceState;
    appContext: IAppContextState;
    personnel: IPersonnelState;
}

const root = (history: History) =>
    combineReducers<IRootState>({
        router: connectRouter(history),
        appContext,
        auth,
        navigation,
        task,
        layout,
        client,
        company,
        project,
        projectStaffing,
        landman,
        performanceComment,
        user,
        office,
        profile,
        state,
        tract,
        search,
        owner,
        phoneNumberType,
        county,
        leasehold,
        fileManagement,
        leaseClause,
        leaseGeneration,
        feedback,
        ownershipContactCategories,
        documentTemplates,
        tags,
        invoice,
        personnel,
    });

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.ts